import style from "../../../assets/scss/sub/purchase/purchaseVoucher.module.scss";
import voucherIcon from "../../../assets/images/sub/purchase_voucher/voucher_icon.svg";
import plusBtnIcon from "../../../assets/images/sub/purchase_voucher/quantity_plus_btn.svg";
import minusBtnIcon from "../../../assets/images/sub/purchase_voucher/quantity_minus_btn.svg";
import React, {useEffect, useMemo, useState} from "react";
import {MainWrapper} from "../MainWrapper";
import {useAppSelector, useLanguage, useLoader, useUserAgent,} from "../../../hooks/hooks";
import {productStatus,} from "../../../store/product/productSlice";
import {DisplayPosition,} from "../../../types/product";
import {orderStatus} from "../../../store/order/orderSlice";
import {useProductDetailGetter} from "./hooks/useProductDetailGetter";
import {usePurchaseVoucherFunctions} from "./hooks/usePurchaseVoucherFunctions";
import {ArticleTitle} from "../ArticleTitle";
import {useTranslation} from "react-i18next";

interface Price {
    regularPrice: number;
    sellingPrice: number;
}

export function PurchaseVoucher() {
    const { t } = useTranslation("productDetail")
    const statusProduct = useAppSelector(productStatus);
    const statusOrder = useAppSelector(orderStatus);
    const {language} = useLanguage();
    const {setLoaderStatus} = useLoader();
    const {isMobile} = useUserAgent();

    const {
        getDiscountText,
        getDetailImageAndVideoComponents,
        // categories,
        onClickPurchaseBtn
    } = usePurchaseVoucherFunctions();

    const [quantity, setQuantity] = useState(1);
    const {getProductDetail, productData} = useProductDetailGetter();
    const [currentDisplayPosition, ] = useState<DisplayPosition>(DisplayPosition.USER_WEB_DCAS)

    const currentData = productData[currentDisplayPosition];
    const productDetailInfo = currentData.info;
    const productImages = currentData.images.desktop;
    const productImagesMobile = currentData.images.mobile;

    const onClickAddQtyBtn = () => {
        setQuantity(quantity + 1);
    };

    const onClickSubtractQtyBtn = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
    };

    // const onClickCategory = (displayPosition: DisplayPosition) => {
    //     setCurrentDisplayPosition(displayPosition)
    //     setQuantity(1)
    // }

    const totalPrice: Price = useMemo(() => {
        if (productDetailInfo) {
            return {
                regularPrice: productDetailInfo.regularPrice * quantity,
                sellingPrice: productDetailInfo.sellingPrice * quantity,
            };
        } else {
            return {
                regularPrice: 0,
                sellingPrice: 0,
            };
        }
    }, [quantity, productDetailInfo]);

    useEffect(() => {
        document.title = `${t("voucher.title")} | ${process.env.REACT_APP_TITLE}`;
        window.scroll({top: 0});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language, currentDisplayPosition]);

    useEffect(() => {
        getProductDetail({
            language: language
        }).then();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setLoaderStatus([statusOrder]);
    }, [setLoaderStatus, statusOrder]);

    useEffect(() => {
        setLoaderStatus([statusProduct]);
    }, [setLoaderStatus, statusProduct]);

    const hasDiscountValue = useMemo(
        () => Boolean(productDetailInfo?.discountValue && productDetailInfo.discountValue > 0),
        [productDetailInfo]
    );

    return (
        <MainWrapper showFooter={true} mainClassName={style.main}>
            <>
                <div className={style.title}>
                    <div className={style.bgItem1}></div>
                    <ArticleTitle title={t("voucher.title")} className={style.textArea} />
                </div>
                {/*<div className={style.title}>*/}
                {/*    <div className={style.bgItem1}/>*/}
                {/*    {categories.map((category, index) => (*/}
                {/*        <div*/}
                {/*            key={index}*/}
                {/*            className={`${category.style} ${currentDisplayPosition === category.position ? style.active : ""}`}*/}
                {/*            onClick={() => onClickCategory(category.position)}*/}
                {/*        />*/}
                {/*    ))}*/}
                {/*</div>*/}

                <div className={style.productDetail}>
                    <div className={style.thumbnail}>
                        {productDetailInfo?.thumbnail.uri && (
                            <img src={productDetailInfo?.thumbnail.uri} alt={"상품 썸네일 이미지"}/>
                        )}
                    </div>
                    <div className={style.desc}>
                        <span className={style.title}>{productDetailInfo?.name}</span>
                        <ul className={style.descList}>
                            {productDetailInfo?.description?.map((desc, idx) => (
                                <li key={`normal-desc-${idx}`}>{desc}</li>
                            ))}
                            {productDetailInfo?.specialDescription?.map((desc, idx) => (
                                <li key={`special-desc-${idx}`} className={style.accent}>
                                    {desc}
                                </li>
                            ))}
                        </ul>
                        <div className={style.dashLine}></div>
                        <div className={style.quantityAndPrice}>
                            <div className={style.quantity}>
                                <button className={style.qtyBtn}>
                                    <img src={minusBtnIcon} alt={"수량 차감 아이콘"} onClick={onClickSubtractQtyBtn}/>
                                </button>
                                <span className={style.number}>{quantity}</span>
                                <button className={style.qtyBtn}>
                                    <img src={plusBtnIcon} alt={"수량 추가 아이콘"} onClick={onClickAddQtyBtn}/>
                                </button>
                            </div>
                            {hasDiscountValue && (
                                <div className={style.regularPrice}>
                                    {totalPrice.regularPrice.toLocaleString()}{t("unit")}
                                </div>
                            )}
                            <div
                                className={`${style.discountPrice} ${hasDiscountValue ? style.positionBottomRow : ""}`}>
                                {hasDiscountValue && (
                                    <>
                                        <img className={style.icon} src={voucherIcon} alt="상품 아이콘"/>
                                        <span className={style.badge}>
                                            {getDiscountText(productDetailInfo, quantity)} {t("saleAmount")}
                                        </span>
                                    </>
                                )}
                                <span className={style.price}>
                                    {totalPrice.sellingPrice.toLocaleString()}{t("unit")}
                                </span>
                            </div>
                        </div>
                        <button className={style.purchaseBtn} onClick={(e) => onClickPurchaseBtn(e,productDetailInfo, quantity)}>
                            {t("btn.purchase")}
                        </button>
                    </div>

                </div>
                <div className={style.imageArea}>
                    <div className={style.bgItem1}></div>
                    <div className={style.bgItem2}></div>
                    <div className={style.bgItem3}></div>
                    {!isMobile ? (
                        <>{getDetailImageAndVideoComponents(productImages)}</>
                    ) : (
                        <>{getDetailImageAndVideoComponents(productImagesMobile)}</>
                    )}
                </div>
            </>
        </MainWrapper>
    );
}
